<template>
 <transition name="bottomSlide" appear>
  <div class="footerModal">
    <CloseIcon class="footerModal__close" color="#656D78" @click.native="$emit('close')"/>
    <listMenu 
    :menu-list="menuList"
    fontColor="#434A54" 
    iconColor="#FF7497"
    headColor="#FF7497"
    padding="20px 20px 0px"/>
  </div>
  </transition>
</template>

<script>
import ListMenu from './ListMenu'
import Overlay from './Overlay'
import CloseIcon from './icon/CloseIcon'

export default {
  name: 'footerModal',
  components:{
    ListMenu,
    Overlay,
    CloseIcon
  },
  data() {
    return {
    }
  },
  props: {
    menuList: {
      type: Array,
      default:() => []
    },
  },
  methods: {

  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.footerModal{
  height: fit-content;
  width: 100%;
  position: fixed;
  background: $col_white;
  bottom: 50px;
  z-index:  90003;

  @include mq('pc') {
    top: 44px;
    left: 0;
    width: 300px;
    height: 100%;
    z-index: 90004;
    box-shadow: 10px 0px 20px rgba(0, 0, 0, 0.1);
  }

  &__close{
    position: absolute;
    right:15px;
    top: 15px
  }
  
}

.bottomSlide-enter-active, .bottomSlide-leave-active {
  transform: translate(0px, 0px);
  transition: transform 500ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  @include mq('pc') {
    transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }
}

.bottomSlide-enter, .bottomSlide-leave-to {
  transform: translateY(100vh) translateY(0px);
  @include mq('pc') {
    transform: translateX(-300px) translateX(0px);
  }
}

ul {
  list-style: none;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/FooterModal.vue